import { CSSProperties, FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useBackButtonToPrevRoute } from '@/hooks/useBackButtonToPrevRoute.tsx';
import { routes } from '@/navigation/routes.tsx';
import ProfileController from '@/api/profile/profile.ts';
import { I18NLanguageCodes } from '@/constants/tg-language-codes.ts';
import {
  languageItemStyle,
  selectedItemMarkStyle
} from '@/pages/Profile/Settings/Locale/styles.ts';
import { InputContent } from '@/components/common/InputContent/InputContent.tsx';
import { catchErrors } from '@/utils/sentry-monitor.tsx';

interface ILanguage {
  label: string;
  value: I18NLanguageCodes;
}

const languages: ILanguage[] = [
  { label: 'English', value: 'en-US' },
  { label: 'Українська', value: 'uk-UK' },
  { label: 'Русский', value: 'ru-RU' }
];

const getLanguageItemStyle = (selected: boolean): CSSProperties => ({
  ...languageItemStyle,
  backgroundColor: '#FFFFFF',
  color: '#1A1A1A',
  border: selected ? '2px solid #1A1A1A' : '2px solid transparent',
  position: 'relative',
  display: 'flex',
  alignItems: 'center'
});

const Locale: FC = () => {
  useBackButtonToPrevRoute(routes.profileSettings, false);

  const { i18n, t } = useTranslation();
  const [selectedLocale, setSelectedLocale] = useState<string>(i18n.language);

  const onConfirm = async (locale: string) => {
    try {
      setSelectedLocale(locale);
      await i18n.changeLanguage(locale);
      await ProfileController.updateLocale({ locale: locale });
    } catch (e) {
      catchErrors(e, true);
    }
  };

  return (
    <div style={{ height: 'calc(100vh - 100px)', paddingTop: '100px' }}>
      <InputContent title={t('change_language_title')}>
        {languages.map((lang) => (
          <div
            key={lang.value}
            style={getLanguageItemStyle(selectedLocale === lang.value)}
            onClick={() => onConfirm(lang.value)}
          >
            <div
              style={{
                padding: '18px 16px',
                borderRadius: '12px',
                cursor: 'pointer',
                flex: 1,
                fontSize: '15px',
                fontWeight: '400'
              }}
            >
              {lang.label}
            </div>
            {selectedLocale === lang.value && (
              <span style={selectedItemMarkStyle}>✓</span>
            )}
          </div>
        ))}
      </InputContent>
    </div>
  );
};

export default Locale;